import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id, data: ApiRequests['api.v1.diary-entries.index']) {
    return await api(route('api.v1.diary-entries.index', projectId), 'get', {
      data,
      casts: {
        date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        text: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        user_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.diary-entries.show', id), 'get');
  },

  async update(id: Id, data: ApiRequests['api.v1.diary-entries.update']) {
    return await api(route('api.v1.diary-entries.update', id), 'patch', {
      data,
    });
  },

  async create(id: Id, data: ApiRequests['api.v1.diary-entries.store']) {
    return await api(route('api.v1.diary-entries.store', id), 'post', {
      data,
    });
  },

  async search(projectId: Id, data: ApiRequests['api.v1.diary-entries.users.search']) {
    return await api(route('api.v1.diary-entries.users.search', projectId), 'get', {
      data,
      casts: {
        name: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },
};
